import RestClient from './rest-client'

export default class Registration extends RestClient {
  static get url () {
    return this.apiUrl + '/registrations'
  }

  static get paramKey () {
    return 'user'
  }

  async update () {
    const payload = {}
    payload[this.constructor.paramKey] = { ...this }
    const { data } = await this.constructor._put(this.constructor.url, payload)
    this._setAttributes(data.data)

    return true
  }
}
